<template>
    <div class="menu-sidebar d-inline-flex">
        <div class="menu-sidebar--toggle">
            <a href="#" @click="toggleMenu()" class="icon-link text-white text-decoration-none">
                <span>{{ open ? 'Close' : 'Menu' }}</span>
                <svg v-if="!open" width="17" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 14" id="gla--hamburger"><g fill="none" fill-rule="evenodd" stroke="currentColor" stroke-linecap="square" stroke-width="2"><path d="M1 1h15M1 7h15M1 13h15"></path></g></svg>
                <svg v-else width="17" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13.435 13.435" id="gla--contract-small"><g fill="none" fill-rule="evenodd" stroke="currentColor" stroke-linecap="square" stroke-width="2"><path d="M1.414 1.414L12.02 12.02"></path><path d="M1.414 12.02L12.02 1.414"></path></g></svg>
            </a>
        </div>

        <div ref="menu" id="main-menu" class="menu-sidebar--main" :class="open ? 'menu-sidebar--main--open' : ''">
            <div class="menu-sidebar--main-items" :style="{height: menuHeight+'px'}" data-scroll-lock-scrollable>
                <MenuItem v-for="(item, index) in menuItems" :menu-height="menuHeight" :key="index" :item="item" />
            </div>

            <div ref="notice" class="menu-sidebar--main--notice">
                <p>How You Can Help Ukraine</p>
                <a href="https://london.gov.uk/programmes-strategies/communities-and-social-justice/migrants-and-refugees/how-you-can-help-ukraine" class="button">
                    Find out what you can do
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    import { disablePageScroll, enablePageScroll } from 'scroll-lock';

    export default {
        name: 'MainMenu',
        props: {
            menuItems: {
                type: Array|Object,
                required: true
            }
        },
        data() {
            return {
                open: false,
                menuHeight: 300
            }
        },
        watch: {
            open(newValue, oldValue) {
                if (newValue) {
                    this.menuHeight = this.$refs.menu.clientHeight - this.$refs.notice.clientHeight;
                }
            }
        },
        methods: {
            toggleMenu: function(){
                this.open ? this.open = false : this.open = true;

                const menu = document.getElementById('main-menu');

                if(this.open){
                    disablePageScroll(menu);
                } else {
                    enablePageScroll(menu);
                }
            }
        }
    }
</script>
